import React, { useState } from 'react';
import OrderListTemplate from '../components/OrderListTemplate';
import { MergedOrder, OrderTabScene } from '../../../types/process/order';
import OrderTriggerActionMap, { OrderTriggerActionProvider, type OrderTriggerTarget } from '../components/OrderTriggerActionMap';
import { getOrderAuditDisplayName, useDefaultQueryFields } from '../order.effect';
import { Typography } from 'antd';
import { useStaffMap } from '../../../services/store/organization.store';

const { Text } = Typography;

/**
 * 暂存待办订单列表页（审核订单 - 暂存待办）
 */
const OrderAuditTodoList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const { staffMap } = useStaffMap();

  /**
   * 触发列表重载
   */
  const reloadList = () => setRefreshKey((k) => k + 1);

  const queryFields = useDefaultQueryFields(OrderTabScene.GroupAuditTodo);

  const targets: OrderTriggerTarget[] = ['reportView', 'auditToLock', 'auditRelease', ];

  const renderListInfo = (order: MergedOrder) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Text style={{ color: '#1677ff' }}>运营: {staffMap.get(order.order.preprocessOperatorId || 0)?.name || '-'}</Text>
      <Text style={{ color: '#1677ff' }}>审核: {getOrderAuditDisplayName(order, staffMap)}</Text>
    </div>
  );

  const renderListActions = (order: MergedOrder) => (
    <OrderTriggerActionMap layout="list" targets={targets} order={order} onReload={reloadList} />
  );

  return (
    <OrderTriggerActionProvider onReload={reloadList}>
      <OrderListTemplate
        refreshKey={refreshKey}
        tabScene={OrderTabScene.GroupAuditTodo}
        defaultScene="tab_audit_todo"
        queryFields={queryFields}
        viewModes={[
          { mode: 'list', label: '订单页', renderActions: renderListActions, renderInfo: renderListInfo },
          // { 
          //   mode: 'table', 
          //   label: '表格页',
          //   tableScene: 'auditStep',
          //   renderActions: renderTableActions,
          // },
        ]}
      />
    </OrderTriggerActionProvider>
  );
};

export default OrderAuditTodoList;
